<script setup lang="ts">
import { computed } from "vue";

import { navigationActions } from "@/action/navigationActions";
import { toggleActions } from "@/action/toggleActions";
import { action, actionMap } from "@/components/action/action";
import MenuItemDelimiter from "@/components/menu/MenuItemDelimiter.vue";
import IconButton from "@/components/ui/IconButton/IconButton.vue";
import { keyboardNavigation } from "@/directives/keyboardNavigation";
import { useBoardMenuStore } from "@/store/boardMenu";
import { useBoardsStore } from "@/store/boards";

const vKeyboardNavLocal = keyboardNavigation();

const hasSolutionBacklogBoard = computed(() => useBoardsStore().hasSolutionBacklogBoard);
const hasSolutionBoard = computed(() => useBoardsStore().hasSolutionBoard);
const shiftDisabled = computed(() => useBoardMenuStore().disabledShiftButton);

const actions = actionMap(navigationActions);
</script>

<template>
  <div class="turn">
    <IconButton
      v-bind="action(toggleActions.shiftMenu)"
      :disabled="shiftDisabled"
      position="right"
    />
  </div>
  <MenuItemDelimiter horizontal />
  <div
    v-keyboard-nav-local.soft-focus.ignore-trigger="{
      selector: '.board-tab-item',
      'roving-tabindex': true,
    }"
    role="tablist"
    aria-orientation="vertical"
    class="boards-item"
  >
    <IconButton
      v-if="hasSolutionBacklogBoard"
      id="solution_backlog_tab"
      v-bind="actions.goToSolutionBacklog"
      class="board-tab-item"
      aria-controls="solution_backlog_panel"
      role="tab"
      position="right"
    />
    <IconButton
      v-if="hasSolutionBoard"
      id="solution_tab"
      v-bind="actions.goToSolution"
      class="board-tab-item"
      aria-controls="solution_panel"
      role="tab"
      position="right"
    />
    <MenuItemDelimiter v-if="hasSolutionBoard" horizontal />
    <IconButton
      id="backlog_tab"
      v-bind="actions.goToBacklog"
      class="board-tab-item"
      aria-controls="backlog_panel"
      role="tab"
      position="right"
    />
    <IconButton
      id="program_tab"
      v-bind="actions.goToProgram"
      class="board-tab-item"
      aria-controls="program_panel"
      role="tab"
      position="right"
    />
    <IconButton
      id="objectives_tab"
      v-bind="actions.goToObjectives"
      class="board-tab-item"
      aria-controls="objectives_panel"
      role="tab"
      position="right"
    />
    <IconButton
      id="risk_tab"
      v-bind="actions.goToRisk"
      class="board-tab-item"
      aria-controls="risk_panel"
      role="tab"
      position="right"
    />
    <MenuItemDelimiter horizontal />
    <IconButton
      id="team_tab"
      v-bind="actions.goToTeam"
      class="board-tab-item"
      aria-controls="team_panel"
      role="tab"
      position="right"
    />
    <IconButton
      id="flex_tab"
      v-bind="actions.goToCanvas"
      class="board-tab-item"
      aria-controls="flex_panel"
      role="tab"
      position="right"
    />
  </div>
</template>

<style lang="scss" scoped>
.boards-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
